<template>
  <div class="setting-main-container">
        <div class="card setting-card">
            <div class="page-header d-flex justify-content-between">
                <div>
                <h3 class="page-title">
                    {{ $t('settings.contacts.title') }}
                </h3>
    
                </div>
                <base-button
                    outline
                    class="add-new-tax"
                    color="theme"
                    @click="addContact"
                >
                    {{ $t('settings.contacts.add_new') }}
                </base-button>
            </div>

            <table-component
              ref="contactTable"
              :show-filter="false"
              :data="contacts"
              table-class="table tax-table"
              class="mb-3"
              
            >
            <table-column
              :sortable="true"
              :label="$t('settings.contacts.name')"
              show="name"
            />
             <table-column
              :sortable="true"
              :label="$t('settings.contacts.designation')"
              show="designation"
            />
            <table-column
              :sortable="true"
              :label="$t('settings.contacts.email')"
              show="email"
            />
            <table-column
              :sortable="true"
              :label="$t('settings.contacts.contact_number')"
              show="contact_number"
            />

            <table-column
              :sortable="false"
              :filterable="false"
              cell-class="action-dropdown"
            >
              <template slot-scope="row">
                <span>{{ $t('settings.tax_types.action') }}</span>
                <v-dropdown>
                  <a slot="activator" href="#">
                    <dot-icon />
                  </a>
                  <v-dropdown-item>
                    <div class="dropdown-item" @click="editContact(row)">
                      <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                      {{ $t('general.edit') }}
                    </div>
                  </v-dropdown-item>
                </v-dropdown>
              </template>
            </table-column>
            
        </table-component>
      </div>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
const { required, maxLength, alpha,minLength,email } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {

      formData:{}
    }
  },
  computed: {
    ...mapGetters('contact', [
      'contacts'
    ]),
  },   
  watch: {
  },
  validations: {
     formData: {}
  },
  created() {
       
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    addContact(){
       this.openModal({
        'title': 'Add Contact',
        'componentName': 'ContactModal',
      })
      this.$refs.contactTable.refresh()
    },
    editContact(data){
       this.openModal({
        'title': 'Edit Contact',
        'componentName': 'ContactModal',
        'id': data.id,
        'data': data
      })
      this.$refs.contactTable.refresh()
    },
  }
}
</script>
